import { useEffect, useRef } from 'react';

import { useModalCustomStore } from '@/utils/store/store';

import SvgTimesCircle from '../Icons/TimesCircle';
import Modal from './Modal';
import ModalDialogCustom from './ModalDialogCustom';

const ModalCustom = () => {
  const { modalVisible, showVisible, content, size } = useModalCustomStore();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (modalVisible) {
      setTimeout(() => {
        scrollToTop();
      }, 100);
    }
  }, [modalVisible]);

  const scrollToTop = () => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Modal
      size={size}
      open={modalVisible}
      handler={() => {}} // Prevenir cierre automático al hacer clic fuera
      className="outline-none"
    >
      <div
        ref={containerRef}
        className="my-3 max-h-[650px] overflow-hidden overflow-y-auto rounded-lg px-8 outline-none"
        onClick={(e) => e.stopPropagation()} // Prevenir propagación de eventos
      >
        <div
          className="z-base absolute end-1 top-1 cursor-pointer"
          onClick={() => showVisible({ modalVisible: false })}
        >
          <SvgTimesCircle className="transition-all hover:text-tundora" />
        </div>

        {content}
      </div>

      <ModalDialogCustom />
    </Modal>
  );
};

export default ModalCustom;
